import { useEffect, useState } from "react";
import api from "../lib/api";

/**
 * Fetch editable page content from the CMS.
 * Returns the raw markdown/text value, or `defaultValue` while loading / on error.
 * For rendered output with formatting (bold, italic, links, lists), wrap the value
 * in the <PageContent /> component instead.
 *
 * Usage:
 *   const mission = usePageContent("about.mission", "Simplifier l'accès...");
 *   return <PageContent value={mission} />;
 */
export default function usePageContent(key, defaultValue = "") {
  const [value, setValue] = useState(defaultValue);
  useEffect(() => {
    let alive = true;
    api.get(`/content/${key}`)
      .then((r) => {
        if (alive && r.data?.value) setValue(r.data.value);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [key]);
  return value;
}
